export enum PspCodesEnum {
    Apcopay = "Apcopay",
    Nuvei = "Nuvei",
    Revolut = "Revolut",
    EMP = "EMP",
    IataPay = "IataPay",
    NoPSP = "NOPSP"
}